export default __webpack_public_path__ + "static/media/img2.7805e26b.png";